import React, { useEffect, useState } from 'react'
import { Select } from "antd";
import { getAutonomousCommunities, MapAutonomousCommunity } from "../../../services/map-municipalities.service";
import { SelectValue } from "antd/lib/select";
import styled from "styled-components";
import { ADD_ALL_ID } from './MapMunicipalitySearchForm';

type MapAutonomousCommunitySelectProps = {
  disabled: boolean,
  selectedAutonomousCommunities: MapAutonomousCommunity[],
  handleSelection: (autonomousCommunity: MapAutonomousCommunity) => void
  handleSelectWholeSpain: () => void
}

export const MapAutonomousCommunitySelect: React.FC<MapAutonomousCommunitySelectProps> = ({
  selectedAutonomousCommunities,
  handleSelectWholeSpain,
  handleSelection,
  disabled
}) => {
  const [autonomousCommunities, setAutonomousCommunities] = useState<MapAutonomousCommunity[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    setLoading(true)
    getAutonomousCommunities().then(data => {
      data.unshift({ id: ADD_ALL_ID, name: "España", separated: true })
      setAutonomousCommunities(data)
      setLoading(false)
    })
  }, [])

  const { Option } = Select

  const onChange = (value: SelectValue) => {
    if (selectedAutonomousCommunities.some(it => it.id === value)) {
      return;
    }
    const autonomousCommunity = autonomousCommunities.find(it => it.id === value)
    if (!autonomousCommunity)
      return;

    if (autonomousCommunity.id === ADD_ALL_ID) {
      handleSelectWholeSpain()
    } else {
      handleSelection(autonomousCommunity)
    }
  }

  return <SearchBar
    size="large"
    showSearch
    placeholder="Comunidad Autónoma"
    optionFilterProp="children"
    onChange={onChange}
    loading={loading}
    disabled={disabled}>
    {autonomousCommunities.map((se: any) => (
      <Option key={se.id} value={se.id}>
        {se.name}
      </Option>
    ))}
  </SearchBar>
}

const SearchBar = styled(Select)`
  width: 100%;
`
